// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { AiFillSetting } from 'react-icons/ai';
import './SettingsTemplate.scss';

type Props = {
  form: Node,
};

class SettingsTemplate extends Component<Props> {
  render() {
    const { form } = this.props;
    return (
      <div className="SettingsTemplate">
        <Helmet>
          <title>프로필 설정 | 캐시바이</title>
        </Helmet>
        <div className="main">{form}</div>
      </div>
    );
  }
}

export default SettingsTemplate;



// WEBPACK FOOTER //
// ./src/components/settings/SettingsTemplate/SettingsTemplate.js